export default {"src":"/_next/static/media/nomad.cdd2f4d1.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};